import React from 'react'
import Reflux from 'reflux'
import i18 from '../../i18'

class HeaderSteps extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStep: props.currentStep,
        };
    }

    render() {
        return (
            <div className='steps-container'>
                <div className='container'>
                    <div className='row '>
                        <ul className='breadcrumb'>
                            <li className='visited' onClick={(step) => this.setStep(1)}>
                                <a className='visited'>1. {i18.STEPS._upload}</a>
                            </li>
                            <li className={this.state.currentStep > 1 ? 'visited' : ''} onClick={(step) => this.setStep(2)}>
                                <a className={this.state.currentStep > 1 ? 'visited' : ''}>2. {i18.STEPS._accountAssignment}</a>
                            </li>
                            <li className={this.state.currentStep > 2 ? 'visited' : ''}>
                                <a className={this.state.currentStep > 2 ? 'visited' : ''}>3. {i18.STEPS._download}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderSteps


// WEBPACK FOOTER //
// ./src/components/customer/headersteps.js